export default __webpack_public_path__ + "static/media/helmet.2ff225e2.svg";